module.exports = {"last_update":"2024-02-29T01:52:30.394Z","api_url":"https://checkin.rmutl.ac.th/api/","ui_url":"https://checkin.rmutl.ac.th/ui","public_token":"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoiY2hlY2tpbl9ybXV0bCIsInR5cGUiOiJ3ZWJfYXBpIiwiY3JlYXRlIjoiMjAyMS0xMS0wNSAxMzo0MDoyMSJ9.HAxY5B7nmuY5cTcXwOmQdWVl-i8paSBB-3Z5jyZRCsU"}


//////////////////
// WEBPACK FOOTER
// ./static/config.json
// module id = 84
// module chunks = 1